
import TeamImage from './TeamImage';

const TeamSection = () => {
  return (
    <div className="py-16 px-4">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground mb-4">
            The Expertise Behind SeniorThrive
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Our multidisciplinary team creates solutions that actually work for older adults and their families.
          </p>
        </div>
        
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="space-y-8">
            <div>
              <h3 className="text-lg font-bold text-foreground mb-3">
                Healthcare Technology
              </h3>
              <p className="text-muted-foreground">
                Expertise in geriatric care, technology development, and senior living solutions 
                designed specifically for older adults.
              </p>
            </div>
            
            <div>
              <h3 className="text-lg font-bold text-foreground mb-3">
                Evidence-Based Approach
              </h3>
              <p className="text-muted-foreground">
                Partnerships with occupational therapists, Certified Aging-in-Place Specialists, 
                and gerontology programs ensure practical recommendations.
              </p>
            </div>
            
            <div>
              <h3 className="text-lg font-bold text-foreground mb-3">
                Real User Input
              </h3>
              <p className="text-muted-foreground">
                Every feature is designed with input from real older adults and families 
                who understand what it means to thrive at home.
              </p>
            </div>
          </div>
          
          <div className="flex justify-center">
            <TeamImage />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamSection;